/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Enter_Driver_NameInputs */

const en_orders_enter_driver_name = /** @type {(inputs: Orders_Enter_Driver_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter driver name`)
};

const es_orders_enter_driver_name = /** @type {(inputs: Orders_Enter_Driver_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa nombre del chofer`)
};

/**
* | output |
* | --- |
* | "Enter driver name" |
*
* @param {Orders_Enter_Driver_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_enter_driver_name = /** @type {((inputs?: Orders_Enter_Driver_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Enter_Driver_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_enter_driver_name(inputs)
	return es_orders_enter_driver_name(inputs)
});